/*
 * Copyright (c) Nexign, JSC, 2024.
 */
/**
 *
 * @author Ilya Baranchikov
 * @version 1.29.0
 * @since 1.29.0
 */

import { TRoundTypes, ceil10, floor10, round10 } from './decimalsFormat';

type TConvertSecondsToMinutesOptions = {
    roundType: TRoundTypes;
    exp?: number;
};

export const convertSecondsToMinutes = (
    seconds: number,
    options: TConvertSecondsToMinutesOptions = { roundType: 'floor', exp: 0 },
): number => {
    if (seconds < 0) {
        return 0;
    }
    const minutes = seconds / 60;

    switch (options.roundType) {
        case 'floor':
            return floor10(minutes, options.exp) as number;
        case 'ceil':
            return ceil10(minutes, options.exp) as number;
        case 'round':
            return round10(minutes, options.exp) as number;
        default:
            return Math.floor(minutes);
    }
};
